// 爆料网内容数据 —— 静态展示数据

export const brand = "爆料网";
export const brandSlogan = "今日热点，实时吃瓜，全网热瓜持续追踪";

export const navLinks = [
  { label: "头条", href: "#headline" },
  { label: "实时爆料", href: "#live" },
  { label: "全网热瓜", href: "#hot" },
  { label: "热点追踪", href: "#track" },
  { label: "话题榜", href: "#topics" },
  { label: "关于我们", href: "#about" },
];

// 顶部滚动条字幕
export const breakingNews = [
  "顶流歌手官宣全国巡回演唱会，首站开票秒空",
  "现象级综艺《星夜盲盒》新一期录制嘉宾名单泄露",
  "某热播剧剧组回应片场争议：已启动内部核查",
  "新生代演员机场造型引热议，粉丝站晒高清生图",
  "电竞圈再爆转会猛料：冠军中单或将易主",
  "知名主播深夜回应节奏，称已保留相关证据",
  "年度大热悬疑剧口碑逆转，豆瓣评分直冲9.2",
  "体坛名将宣布下赛季转战新东家",
];

// 头条故事
export const headlineStory = {
  kicker: "今日头条",
  title: "现象级综艺收官夜引全网狂欢，话题阅读量三小时破十亿，热搜前排被它霸榜",
  summary:
    "从素人到舞台王者，一场从深夜持续到凌晨的收官直播，把台前幕后、选手心态与幕后花絮全部推上风口浪尖。为什么这档节目能接连点燃今夏热点？我们用一篇文章带你看懂整场热搜背后的故事。",
  tag: "爆",
  cat: "影视综艺",
  time: "2小时前",
  views: "2860万",
  image:
    "https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20at%20night%20with%20dramatic%20red%20and%20gold%20spotlights%2C%20silhouetted%20crowd%20raising%20phones%20and%20lightsticks%2C%20smoke%20and%20light%20rays%20cutting%20through%2C%20editorial%20entertainment%20news%20photography%2C%20cinematic%20warm%20contrast%2C%20high%20energy%2C%20vibrant%20atmospheric%20mood&width=1600&height=900&seq=headline-stage-2026-x1&orientation=landscape",
  body: [
    "收官夜当晚，节目组将舞台布置成环形剧场，数千名观众挥舞应援棒，现场气氛被一首首竞演曲目推向顶点。随着最终排名揭晓，相关词条以肉眼可见的速度冲上前排热搜。",
    "业内分析认为，这档节目能够持续发酵的原因，并不只是选手本身，更在于它重新定义了观众与舞台的连接方式。从实时弹幕、二创视频到线下应援，几乎每个环节都能衍生出新话题。",
    "多位资深媒体人评价，这将是今年最值得复盘的一档内容产品。节目所引发的讨论，已经远远超出屏幕本身，成为社交平台上一场持续进行的公共事件。",
  ],
};

// 热搜榜侧栏
export const sideHotList = [
  { rank: 1, title: "星夜盲盒收官夜热搜霸榜", heat: "986万", cat: "影视综艺" },
  { rank: 2, title: "顶流歌手巡回演唱会官宣", heat: "874万", cat: "明星动态" },
  { rank: 3, title: "悬疑剧《长夜将明》口碑爆发", heat: "793万", cat: "影视综艺" },
  { rank: 4, title: "冠军中单转会传闻再添实锤", heat: "712万", cat: "电竞游戏" },
  { rank: 5, title: "新生代演员机场生图出圈", heat: "689万", cat: "明星动态" },
  { rank: 6, title: "现象级主播回应场外节奏", heat: "634万", cat: "网络热梗" },
  { rank: 7, title: "体坛名将宣布转战新东家", heat: "578万", cat: "体坛风云" },
  { rank: 8, title: "年度音乐节阵容正式官宣", heat: "521万", cat: "音乐现场" },
  { rank: 9, title: "热播剧导演回应删减争议", heat: "476万", cat: "影视综艺" },
  { rank: 10, title: "城市青年夜经济观察走红", heat: "402万", cat: "社会民生" },
];

export const hotCategories = [
  { key: "star", label: "明星动态" },
  { key: "film", label: "影视综艺" },
  { key: "music", label: "音乐现场" },
  { key: "net", label: "网络热梗" },
  { key: "game", label: "电竞游戏" },
  { key: "sport", label: "体坛风云" },
  { key: "tech", label: "科技数码" },
  { key: "social", label: "社会民生" },
];

// 全网热瓜故事卡片
export const gridStories = [
  {
    id: "s01",
    cat: "star",
    title: "顶流歌手新歌空降音乐平台，一小时收听量刷新纪录",
    summary: "新歌延续了歌手的标志性声线，却加入了此前少见的电子编曲，上线一小时便刷新华语单曲首日收听纪录。",
    tag: "爆",
    time: "38分钟前",
    views: "1203万",
    image:
      "https://readdy.ai/api/search-image?query=Studio%20microphone%20with%20warm%20neon%20glow%20in%20dark%20recording%20booth%2C%20soft%20red%20and%20amber%20backlight%2C%20abstract%20editorial%20music%20news%20visual%2C%20cinematic%20depth%2C%20sleek%20professional%20ambiance%2C%20high%20contrast%20warm%20tones&width=800&height=500&seq=story-star-s01&orientation=landscape",
  },
  {
    id: "s02",
    cat: "star",
    title: "新生代演员深夜晒练舞视频，疑似为新剧角色蓄力",
    summary: "一段30秒的练舞短视频引发粉丝热议，动作干脆利落，评论区都在猜测这位小花是否在为武侠新角色做准备。",
    tag: "热",
    time: "1小时前",
    views: "786万",
    image:
      "https://readdy.ai/api/search-image?query=Dancer%20in%20silhouette%20practicing%20in%20a%20bright%20studio%20with%20large%20windows%20and%20morning%20light%2C%20clean%20minimal%20background%2C%20editorial%20entertainment%20photography%2C%20warm%20natural%20tones%2C%20dynamic%20motion%20blur%2C%20elegant%20composition&width=800&height=500&seq=story-star-s02&orientation=landscape",
  },
  {
    id: "s03",
    cat: "film",
    title: "悬疑剧《长夜将明》结局封神，全网二刷热潮来袭",
    summary: "剧集尾声埋下的伏笔逐条回收，真相揭开瞬间引爆讨论，原著党与剧粉罕见达成一致，纷纷开启二刷模式。",
    tag: "爆",
    time: "2小时前",
    views: "1650万",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20dark%20mystery%20television%20drama%20still%20with%20a%20figure%20standing%20near%20a%20rain-soaked%20neon%20street%20at%20night%2C%20deep%20shadows%2C%20crimson%20and%20amber%20neon%20reflections%2C%20cinematic%20suspense%2C%20editorial%20review%20visual%2C%20atmospheric&width=800&height=500&seq=story-film-s03&orientation=landscape",
  },
  {
    id: "s04",
    cat: "film",
    title: "现象级综艺《星夜盲盒》幕后花絮独家盘点",
    summary: "节目组首次放出未播幕后：评委表情包、选手夜聊名场面、导播间的惊险瞬间，一次性满足你的好奇心。",
    tag: "热",
    time: "3小时前",
    views: "934万",
    image:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20vibrant%20television%20variety%20show%20studio%2C%20colorful%20stage%20set%2C%20cameras%20and%20crew%20in%20motion%2C%20playful%20warm%20lighting%2C%20editorial%20entertainment%20documentary%20visual%2C%20energetic%20candid%20mood&width=800&height=500&seq=story-film-s04&orientation=landscape",
  },
  {
    id: "s05",
    cat: "music",
    title: "年度音乐节阵容官宣，压轴惊喜悬念拉满",
    summary: "超强阵容里藏着一位神秘的X位压轴嘉宾，官方只放出一句提示，粉丝们已开始疯狂猜人。",
    tag: "热",
    time: "4小时前",
    views: "598万",
    image:
      "https://readdy.ai/api/search-image?query=Large%20open-air%20music%20festival%20main%20stage%20at%20golden%20hour%20with%20colorful%20lights%20and%20big%20crowd%20silhouettes%2C%20confetti%20in%20air%2C%20warm%20sunset%20backdrop%2C%20editorial%20event%20photography%2C%20joyful%20high%20energy&width=800&height=500&seq=story-music-s05&orientation=landscape",
  },
  {
    id: "s06",
    cat: "music",
    title: "老牌乐队重组巡演，经典曲目重新编曲引泪目",
    summary: "解散多年的传奇乐队官宣重组，将把二十年前的经典专辑搬上舞台，预售刚开即创下平台纪录。",
    tag: "新",
    time: "5小时前",
    views: "421万",
    image:
      "https://readdy.ai/api/search-image?query=Nostalgic%20band%20stage%20with%20vintage%20guitars%20and%20analog%20amps%20under%20warm%20spotlight%2C%20retro%20concert%20mood%2C%20soft%20haze%20and%20amber%20lighting%2C%20editorial%20music%20news%20visual%2C%20timeless%20sentimental%20tone&width=800&height=500&seq=story-music-s06&orientation=landscape",
  },
  {
    id: "s07",
    cat: "net",
    title: "热梗“已老实求放过”为何火到停不下来",
    summary: "从一个直播事故到全网玩梗，这句台词的火爆路径，恰好折射出当下年轻人的表达方式与情绪出口。",
    tag: "热",
    time: "6小时前",
    views: "877万",
    image:
      "https://readdy.ai/api/search-image?query=Playful%20meme%20collage%20style%20still%20life%20with%20smartphones%20showing%20trending%20comments%2C%20floating%20text%20bubbles%20and%20stickers%2C%20warm%20pop%20colors%2C%20youthful%20social%20media%20culture%20visual%2C%20fun%20modern%20composition&width=800&height=500&seq=story-net-s07&orientation=landscape",
  },
  {
    id: "s08",
    cat: "net",
    title: "主播回应“录音门”事件：已委托团队处理并保留证据",
    summary: "针对网络流传的疑似录音，主播深夜开播正面回应，强调内容断章取义，并透露将走法律途径维权。",
    tag: "爆",
    time: "7小时前",
    views: "1092万",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20setup%20with%20ring%20light%20and%20microphone%20on%20a%20desk%20at%20night%2C%20deep%20red%20and%20dark%20background%2C%20editorial%20tech%20and%20online%20culture%20visual%2C%20focused%20intense%20mood%2C%20cinematic%20lighting&width=800&height=500&seq=story-net-s08&orientation=landscape",
  },
  {
    id: "s09",
    cat: "game",
    title: "冠军中单转会传闻再添实锤，战队官方深夜回应",
    summary: "多方爆料指向核心选手即将离队，战队官博一句“一切以官宣为准”被解读为默认，粉丝心情复杂。",
    tag: "热",
    time: "8小时前",
    views: "731万",
    image:
      "https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20glowing%20trophy%20and%20players%20in%20silhouette%20under%20neon%20team%20lights%2C%20red%20and%20amber%20accent%20glow%2C%20editorial%20gaming%20news%20visual%2C%20dynamic%20competitive%20mood%2C%20sleek%20dark%20background&width=800&height=500&seq=story-game-s09&orientation=landscape",
  },
  {
    id: "s10",
    cat: "game",
    title: "新赛季版本大改，游戏主播连夜研究冲分套路",
    summary: "装备与地图全面改版，职业选手与高玩主播开启“熬夜内卷”，玩家社区涌现大量上分攻略。",
    tag: "新",
    time: "9小时前",
    views: "466万",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20mechanical%20gaming%20keyboard%20and%20mouse%20with%20RGB%20red%20glow%20in%20a%20dark%20room%2C%20monitor%20light%20reflecting%2C%20editorial%20esports%20technology%20visual%2C%20intense%20gaming%20atmosphere%2C%20sleek%20modern&width=800&height=500&seq=story-game-s10&orientation=landscape",
  },
  {
    id: "s11",
    cat: "sport",
    title: "体坛名将宣布转战新东家，未来去向引多方猜测",
    summary: "一条简短的官宣动态引爆体育圈，多家豪门被点名，球迷已开始分析其加盟后的战术变化。",
    tag: "热",
    time: "10小时前",
    views: "683万",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20stadium%20floodlights%20at%20dusk%20with%20empty%20track%20and%20field%2C%20deep%20warm%20sky%2C%20sporting%20news%20editorial%20visual%2C%20atmospheric%20anticipation%20mood%2C%20powerful%20composition%2C%20high%20contrast&width=800&height=500&seq=story-sport-s11&orientation=landscape",
  },
  {
    id: "s12",
    cat: "sport",
    title: "女足联赛上演惊天逆转，补时绝杀冲上热搜",
    summary: "一度两球落后却连扳三球，终场前的读秒绝杀让全场沸腾，姑娘们的拼搏精神收获全网点赞。",
    tag: "新",
    time: "11小时前",
    views: "512万",
    image:
      "https://readdy.ai/api/search-image?query=Football%20players%20celebrating%20in%20silhouette%20under%20stadium%20lights%20at%20night%2C%20turf%20and%20confetti%2C%20dynamic%20action%2C%20editorial%20sports%20photography%2C%20emotional%20victory%20mood%2C%20warm%20dramatic%20tone&width=800&height=500&seq=story-sport-s12&orientation=landscape",
  },
  {
    id: "s13",
    cat: "tech",
    title: "新一代折叠屏旗舰发布，铰链与影像成最大看点",
    summary: "厂商在铰链耐用性上堆料，影像系统主打暗光人像，发布会后真机上手评测迅速刷屏数码圈。",
    tag: "新",
    time: "12小时前",
    views: "389万",
    image:
      "https://readdy.ai/api/search-image?query=Premium%20foldable%20smartphone%20showcased%20on%20a%20minimal%20warm%20display%20stand%20with%20soft%20studio%20lighting%2C%20elegant%20product%20photography%2C%20editorial%20tech%20news%20visual%2C%20clean%20modern%20background&width=800&height=500&seq=story-tech-s13&orientation=landscape",
  },
  {
    id: "s14",
    cat: "social",
    title: "城市青年夜经济观察走红：夜宵摊主的一天",
    summary: "深夜十二点，一座城市的另一面才刚刚苏醒。一篇纪实报道让无数打工人找到共鸣。",
    tag: "热",
    time: "13小时前",
    views: "645万",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20night%20street%20food%20stall%20with%20warm%20lantern%20light%20and%20steam%20rising%20from%20hot%20wok%2C%20people%20gathering%20at%20night%2C%20documentary%20editorial%20photography%2C%20authentic%20city%20life%2C%20warm%20nostalgic%20tone&width=800&height=500&seq=story-social-s14&orientation=landscape",
  },
];

// 热点追踪 —— 进行中的事件，含阶段时间线
export const trackEvents = [
  {
    id: "t01",
    title: "《星夜盲盒》收官争议全追踪",
    cat: "影视综艺",
    status: "持续发酵中",
    desc: "从赛果争议到制作幕后，话题已延伸出十余条热搜。我们持续记录各方回应与事实梳理。",
    image:
      "https://readdy.ai/api/search-image?query=Dark%20moody%20television%20studio%20control%20room%20with%20many%20screens%20showing%20trending%20charts%20and%20stage%20cameras%2C%20deep%20red%20ambient%20light%2C%20editorial%20news%20room%20visual%2C%20suspenseful%20breaking%20story%20mood%2C%20cinematic&width=1200&height=680&seq=track-event-t01&orientation=landscape",
    stages: [
      { time: "20:00", text: "节目收官直播开始，全网讨论度攀升" },
      { time: "23:40", text: "最终排名揭晓，相关词条冲上前排热搜" },
      { time: "02:10", text: "节目组发布长文声明，回应制作争议" },
      { time: "08:30", text: "多位业内人士发声，话题仍在发酵" },
    ],
  },
  {
    id: "t02",
    title: "主播“录音门”事件进展实录",
    cat: "网络热梗",
    status: "调查推进中",
    desc: "围绕疑似录音的真伪、来源与传播，我们同步跟进主播回应、平台处理与法律维权进展。",
    image:
      "https://readdy.ai/api/search-image?query=Rows%20of%20microphones%20at%20a%20press%20desk%20in%20front%20of%20a%20dark%20blurred%20background%2C%20dramatic%20red%20and%20white%20lighting%2C%20editorial%20news%20conference%20visual%2C%20serious%20investigative%20mood%2C%20cinematic%20depth&width=1200&height=680&seq=track-event-t02&orientation=landscape",
    stages: [
      { time: "21:05", text: "网传录音片段开始在各平台传播" },
      { time: "23:20", text: "涉事主播开播正面回应，情绪激动" },
      { time: "00:15", text: "主播透露已委托团队处理并保留证据" },
      { time: "09:00", text: "平台回应将配合核实相关内容" },
    ],
  },
  {
    id: "t03",
    title: "悬疑剧《长夜将明》口碑大爆发",
    cat: "影视综艺",
    status: "热度持续走高",
    desc: "结局播出后口碑一路飙升，关于伏笔回收、续集可能的讨论仍在持续，二刷率创下新高。",
    image:
      "https://readdy.ai/api/search-image?query=Foggy%20mystery%20mansion%20entrance%20at%20night%20with%20single%20warm%20lamp%20glow%20and%20long%20shadow%2C%20crimson%20and%20amber%20tones%2C%20editorial%20drama%20review%20visual%2C%20mysterious%20elegant%20atmosphere&width=1200&height=680&seq=track-event-t03&orientation=landscape",
    stages: [
      { time: "20:00", text: "大结局上线，豆瓣评分持续走高" },
      { time: "22:30", text: "“伏笔回收”登上热搜，讨论破百万" },
      { time: "01:40", text: "原著党与剧粉和解，推荐二刷" },
      { time: "12:00", text: "片方回应网友关于续集提问" },
    ],
  },
];

// 吃瓜话题标签
export const hotTopics = [
  { tag: "#星夜盲盒收官", heat: 986 },
  { tag: "#长夜将明结局", heat: 912 },
  { tag: "#顶流演唱会官宣", heat: 864 },
  { tag: "#新生代演员造型", heat: 803 },
  { tag: "#已老实求放过", heat: 756 },
  { tag: "#冠军中单转会", heat: 701 },
  { tag: "#女足惊天逆转", heat: 655 },
  { tag: "#年度音乐节阵容", heat: 620 },
];

// 编辑精选
export const editorPicks = [
  { title: "本周娱乐圈大事记：从官宣到道歉，谁在认真营业", cat: "明星动态", time: "18分钟前", views: "420万" },
  { title: "复盘这档爆款综艺，为什么越骂越火？", cat: "影视综艺", time: "42分钟前", views: "387万" },
  { title: "电竞转会市场大摸底：这份名单含金量几何", cat: "电竞游戏", time: "1小时前", views: "302万" },
  { title: "热梗考古：那些年我们追过的神评论", cat: "网络热梗", time: "1小时前", views: "251万" },
];

export const aboutStats = [
  { num: "24h", label: "实时滚动更新" },
  { num: "8+", label: "热门内容栏目" },
  { num: "10w+", label: "全网热点追踪" },
  { num: "100+", label: "每日新鲜爆料" },
];

export const testimonials = [
  {
    name: "青柠不加糖",
    role: "深夜冲浪用户",
    text: "每天睡前刷一遍实时爆料就成了习惯，节奏够快，标题也不标题党，瓜吃得明明白白。",
    stars: 5,
  },
  {
    name: "北纬三十七度",
    role: "娱乐圈观察者",
    text: "热点追踪的进度条做得太好了，一整个事件从发酵到澄清的来龙去脉清清楚楚，省了我到处考古的时间。",
    stars: 5,
  },
  {
    name: "一只吃瓜猹",
    role: "影视爱好者",
    text: "全网热瓜的分类很清爽，不会一上来就糊一脸。想看哪个栏目点一下就行，更新是真勤快。",
    stars: 4,
  },
  {
    name: "半糖去冰",
    role: "上班族",
    text: "早上通勤花几分钟就能把昨夜的瓜补齐，内容客观也尊重当事人，这点很圈粉。",
    stars: 5,
  },
];

export const faqs = [
  {
    q: "爆料网的内容多久更新一次？",
    a: "爆料网实行全天候滚动更新，实时爆料栏目会跟随热点事件不断刷新。热门事件则配合热点追踪进度持续补充最新进展，确保你能第一时间掌握正在发酵的瓜。",
  },
  {
    q: "如何判断一条爆料的真实性？",
    a: "我们会优先采用多方信源交叉核实的内容，对于无法第一时间证实的信息会明确标注来源与核实状态，并在热点追踪中同步跟进后续回应与澄清，避免片面信息误导读者。",
  },
  {
    q: "爆料网是否只报道娱乐圈内容？",
    a: "不止于此。除了明星动态与影视综艺，我们还覆盖音乐现场、电竞游戏、体坛风云、科技数码与社会民生等多个栏目，力求呈现立体而多元的全网热点。",
  },
  {
    q: "为什么部分内容不直接点名当事人？",
    a: "在信息尚未完全证实或涉及个人隐私时，我们坚持审慎报道原则，采用可辨识但不冒犯的方式呈现，既满足信息需求，也尊重每一位当事人的合法权益。",
  },
  {
    q: "我能通过爆料网反馈线索或投稿吗？",
    a: "当然可以。欢迎通过文末的联系邮箱与我们沟通，我们会认真核查每一条线索，并在核实后纳入相关栏目与热点追踪中。",
  },
  {
    q: "网站会保存或滥用我的浏览信息吗？",
    a: "我们仅在提供服务所必需的最小范围内处理浏览数据，不对外出售用户信息，也不会以匿名形式公开任何个体浏览记录。",
  },
];

export const footerGroups = [
  {
    title: "内容栏目",
    links: ["今日热点", "实时爆料", "全网热瓜", "热点追踪", "话题榜", "编辑精选"],
  },
  {
    title: "关于站点",
    links: ["关于我们", "报道原则", "版权声明", "联系方式", "广告合作", "加入我们"],
  },
  {
    title: "热门话题",
    links: ["星夜盲盒", "长夜将明", "转会市场", "年度音乐节", "热梗考古", "夜经济观察"],
  },
];